<template>
    <div class="help-question-mark-container">
        <div class="help-question-mark">
            <img src="/img/question-circle.svg" alt="question">
        </div>
        <div class="help-question-content">
            <div class="help-question-triangle"></div>
            <div class="help-question-content__container">
                <h5 class="text-white">{{ title }}</h5>
                <p class="text-white" v-html="description"></p>
                <img v-if="image" :src="image" alt="image">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            // console.log('Component mounted.')
        },
        props: {
            title: String,
            description: String,
            image: {
                type: String,
                default: null
            }
        },
    }
</script>